import { usePortalBranding } from "@/contexts/portalBranding";

/**
 * Attribution shown only inside a white-label portal.
 *
 * Renders nothing on the marketplace, where "powered by Reveshare" on
 * Reveshare would be odd. Deliberately quiet — it is an attribution line, not
 * a call to action, and it sits inside a brand's own portal.
 *
 * Not rendered while branding is still resolving: appearing a beat after the
 * page settles is better than appearing on the marketplace and vanishing.
 */
export function PoweredByReveshare({ className = "" }: { className?: string }) {
  const { isWhiteLabel, isReady } = usePortalBranding();
  if (!isReady || !isWhiteLabel) return null;

  return (
    <p className={`text-center text-xs text-muted-foreground py-4 ${className}`}>
      Powered by{" "}
      <a
        href="https://reveshare.com"
        target="_blank"
        rel="noreferrer"
        className="underline underline-offset-2 hover:text-foreground transition-colors"
      >
        Reveshare
      </a>
    </p>
  );
}
